import videojs, { VideoJsPlayer } from 'video.js';

import { Event } from '@src/types/event';
import { getIsWholeElementInViewport } from '@src/utils/measure';

import BaseNormalizer from './BaseNormalizer';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Options {}

export const PLUGIN_NAME = 'eventManagerReachPlayerNormalizer';

class ReachPlayerNormalizer extends BaseNormalizer {
  vjsPlayer: VideoJsPlayer;

  constructor(player: VideoJsPlayer, options?: Options) {
    super(player, options);
    this.vjsPlayer = player;

    this.setupReachListeners();
  }

  private setupReachListeners() {
    window.addEventListener('scroll', this.handleReachPlayerDetection, {
      passive: true,
    });
    window.addEventListener('resize', this.handleReachPlayerDetection, {
      passive: true,
    });

    this.handleReachPlayerDetection();
  }

  private disposeReachListeners() {
    window.removeEventListener('scroll', this.handleReachPlayerDetection);
    window.removeEventListener('resize', this.handleReachPlayerDetection);
  }

  private handleReachPlayerDetection = () => {
    if (
      !this.state.isPlayerReached &&
      getIsWholeElementInViewport(this.vjsPlayer.contentEl())
    ) {
      this.setState({ isPlayerReached: true });
      this.disposeReachListeners();
      this.trigger(Event.REACH, this.createCommonEventData());
    }
  };

  dispose() {
    this.disposeReachListeners();
    super.dispose();
  }
}

videojs.registerPlugin(PLUGIN_NAME, ReachPlayerNormalizer);

export type ReachPlayerNormalizerFactoryFn = (
  options?: Options
) => ReachPlayerNormalizer;

export default ReachPlayerNormalizer;
